const REGIONAL_INDICATOR_OFFSET = 127397;

export function buildCountryFlagEmoji(countryCode: string): string {
  const regionalIndicatorCharacters = countryCode
    .toUpperCase()
    .split('')
    .map(function toRegionalIndicator(letter) {
      return String.fromCodePoint(letter.charCodeAt(0) + REGIONAL_INDICATOR_OFFSET);
    });
  return regionalIndicatorCharacters.join('');
}
